import { PaymentMethod } from "../models/payment-method";
import { httpGet } from "./http-client";

const apiUrl = '/api/paymentmethods';

export const getSalePaymentMethods = () => httpGet<PaymentMethod[]>(`${apiUrl}/sales`);
export const getPurchasePaymentMethods = () => httpGet<PaymentMethod[]>(`${apiUrl}/purchases`);
export const getLoanPaymentMethods = () => httpGet<PaymentMethod[]>(`${apiUrl}/loans`);
